import { ParsedUrlQuery } from 'querystring';
import axios from "axios";
import { GetStaticPaths, GetStaticProps } from "next";
import { ArticleDetailProps } from '@/components/Mamapedia/constants';
import Article from '@/components/Mamapedia/Article';
import Footer from '@/components/Footer';
import MamapediaHeader from '@/components/Header/MamapediaHeader';
import Error from "next/error";


interface MamapediaProps {
  article: ArticleDetailProps | undefined;
}

interface ArticleParams extends ParsedUrlQuery {
  slug: string;
}

const MamapediaPage = ({
  article,
}: MamapediaProps) => {

  if (!article) {
    return (<></>)
  }

  return (
    <>
      <MamapediaHeader />
      <Article article={article} />
      <Footer />
    </>
  )
}

export default MamapediaPage

export const getStaticProps: GetStaticProps<ArticleParams> = async ({ params }) => {
  const { slug } = params || {}; // Set a default empty object if params is undefined

  const lastSlug = slug && slug.length > 0 ? slug[slug.length - 1] : '';

  if (lastSlug !== '') {
    try {
      const response = await axios.get(
        process.env.NEXT_PUBLIC_API_URL! + process.env.NEXT_PUBLIC_API_MAMAPEDIA_ARTICLE! + "/" + lastSlug
      );

      if (response.status === 404) {
        return {
          notFound: true,
        }
      }

      return {
        props: { article: response.data, slug: slug ? slug.toString() : '' }, // Ensure 'slug' is of type 'string'
        revalidate: 60 * 60 * 12, // 12 hours
      }
    } catch (error) {
      console.error("Error fetching product data: ", slug, error);

      if (axios.isAxiosError(error)) {
        if (error.response?.status === 404) {
          return {
            notFound: true,
          }
        } else {
          return (
            <Error statusCode={500} />
          )
        }
      } else {
        return (
          <Error statusCode={500} />
        )
      }
    }
  } else {
    return {
      notFound: true,
    }
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  // 根據API獲取所有可能的slug
  // const response = await fetch('/api/allSlugs');
  // const slugs = await response.json();
  const slugs = ["cara-memilih-cemilan-yang-aman-dan-menyehatkan-untuk-anak-anak"]

  const paths = slugs.map((slug: string) => ({
    params: { slug: [slug] },
  }));

  return {
    paths,
    fallback: 'blocking',
  };
};
